//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getObtain, handleMedals } from '../card/utils'
import addConsultant from '@/common/mixins/addConsultant'
import detailSubPage from '@/common/mixins/detailSubPage'

import Service from '@/service'
import PublicService from '@/service/public'

import Loading from '@/components/views/loading'

import { DEFAULT_HEADIMG } from '../const'
import { LEVEL_MAP } from '@/constant'
import Item from './_item'
import Empty from './_empty'

import { APPLY_PIC } from '@/config'

import official_customer_service from '@/common/mixins/official_customer_service'
import pagination from '@/common/mixins/pagination'

import { checkBuildingPhoneAuth } from '@/common/utils/map_view_data'

import { DEFAULT_PER }  from '@/config'

export default {
    mixins: [
        addConsultant,
        detailSubPage,
        official_customer_service,
        pagination
    ],
    name: 'CONSULTANTS',
    data () {
        return {
            building: {
                name: ''
            },
            consultant: {},
            APP_NAME: `${process.env.APP_NAME}`,
            from: '',
            layout_id: '',
            force_phone_auth: false
        }
    },
    mounted () {
        const { from, layout_id } = this.$route.query
        this.from = from || ''
        this.layout_id = layout_id
        Service.init()
            .then(this.getBuilding)
            .then(this.getData)
    },
    onPullDownRefresh () {
        if (!this.loading) {
            this.page = 1
            this.getData()
        }
    },
    methods: {
        getBuilding () {
            const { id } = this.$route.query
            Service.getBuilding(id).then((data) => {
                console.error(data.activities)
                this.force_phone_auth = checkBuildingPhoneAuth(data)
                return data
            })
        },
        getData () {
            this.loading = true
            const { page } = this
            const { id, consultant_group_id } = this.$route.query
            Service.getConsultants({
                page,
                building_id: id || '',
                consultant_group_id: consultant_group_id || '',
                per: DEFAULT_PER
            }).then(({ items, building }) => {
                this.building = building
                items.forEach(item => {
                    item.excellect_obtain = getObtain(item, 1)
                    item.perfessional_obtain = getObtain(item, 2)
                    handleMedals(item)
                    item.type = LEVEL_MAP[item.level]
                    item.weixin_headimgurl = item.weixin_headimgurl || DEFAULT_HEADIMG
                })
                this.handleData({ items })
            })
            Service.getMyConsultant().then(data => {
                this.consultant = data
            })
        },
        goCall () {
            this.$showCallModal(this.getPhoneCall, '楼盘详情页——电话拨打')
        },
        getPhoneCall () {
            const { id } = this.$route.query
            PublicService.getPhonePosition({
                building_id: id
            }).then(({ phone }) => {
                wx.makePhoneCall({
                    phoneNumber: phone,
                    success: () => {}
                })
            })
        },
    },
    components: {

        Loading,
        Item,
        Empty
    }
}
